import React from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

// Animation variant
const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};


const HotelReservation = () => {
  return (
    <div className="max-w-screen-xl mt-44 mb-20 mx-auto py-16 px-6 md:px-20">
      {/* Heading */}
      <motion.h1
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        className="text-4xl font-bold text-center text-yellow-600 mb-12"
      >
        🏨 Hotels Reservation
      </motion.h1>

      {/* Theory / Description */}
      <motion.div
        initial="hidden"
        animate="visible"
        custom={1}
        variants={fadeIn}
        className="text-center max-w-3xl mx-auto text-gray-700 text-lg leading-relaxed mb-16"
      >
      Planning a perfect stay just got easier. Whether you're traveling for business, leisure, or a special occasion, our hotel offers the ideal blend of comfort, convenience, and care. From modern rooms and premium amenities to warm hospitality, every aspect of your stay is thoughtfully crafted to make your visit memorable. Reserve your spot now and experience a relaxing escape like never before.
      </motion.div>

      {/* Why Choose Us Cards */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeIn}
        custom={2}
        className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-center mb-20"
      >
        {[
          { title: "Luxury Rooms", icon: "🛏️", desc: "Spacious and elegant accommodations for a royal experience." },
          { title: "Scenic Locations", icon: "🌄", desc: "Beautiful surroundings and peaceful atmosphere." },
          { title: "Free Wi-Fi", icon: "📶", desc: "Stay connected with high-speed internet access." },
          { title: "24/7 Support", icon: "📞", desc: "We're always available for your comfort and convenience." },
          { title: "Multi-Cuisine Restaurant", icon: "🍽️", desc: "Delight your taste buds with global flavors." },
          { title: "Easy Access", icon: "🗺️", desc: "Located near major transport hubs and tourist attractions." },
        ].map((item, index) => (
          <motion.div
            key={index}
            custom={index + 3}
            variants={fadeIn}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition duration-300"
          >
            <div className="text-4xl mb-3">{item.icon}</div>
            <h3 className="font-semibold text-xl text-yellow-600 mb-2">{item.title}</h3>
            <p className="text-gray-600">{item.desc}</p>
          </motion.div>
        ))}
      </motion.div>

      {/* Contact / Enquiry Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={10}
        variants={fadeIn}
        className="bg-yellow-100 p-10 rounded-2xl shadow-lg"
      >
        <h2 className="text-2xl font-bold text-yellow-700 mb-6 text-center">📞 For Enquiries & Reservations</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-center text-gray-800 text-lg">
          <div className="flex items-center justify-center space-x-3">
            <FaPhoneAlt className="text-yellow-600" />
            <span>+91 9327953295 / +91 6377659957</span>
          </div>
          <div className="flex items-center justify-center space-x-3">
            <FaEnvelope className="text-yellow-600" />
            <span>contact@vamikatours.com</span>
          </div>
          <div className="flex items-center justify-center space-x-3">
            <FaMapMarkerAlt className="text-yellow-600" />
            <span>Ahmedabad, Gujarat</span>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default HotelReservation
